import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { trackEvent } from '../utils/metaPixel';
export function Offer() {
  return <section id="offer" className="py-24 relative" data-id="element-122">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-green/5" data-id="element-123" />

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-[#111] to-[#050505] border-2 border-brand-green rounded-[2.5rem] p-8 lg:p-16 text-center shadow-[0_0_100px_rgba(0,255,136,0.1)]" data-id="element-125">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-green/20 mb-8" data-id="element-126">
            <Zap className="w-8 h-8 text-brand-green" data-id="element-127" />
          </div>

          <h2 className="text-3xl lg:text-5xl font-bold mb-6" data-id="element-128">
            Get the entire Wearable Fix System plus all 3 high-value bonuses.
          </h2>

          <p className="text-xl text-brand-gray mb-10" data-id="element-129">
            Stop being a victim of your data and start mastering your recovery
            today.
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-130">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-red/20 border border-brand-red/40 text-brand-red text-xs font-mono font-bold tracking-widest uppercase mb-4 animate-pulse" data-id="element-131">
              ⏱ Flash Offer · Only For A Few Hours
            </div>
            <div className="text-brand-gray text-lg mb-2 font-mono" data-id="element-132">
              Total Value:{' '}
              <span className="line-through decoration-brand-red decoration-2" data-id="element-133">
                $197
              </span>{' '}
              · Regular:{' '}
              <span className="line-through decoration-brand-red decoration-2" data-id="element-134">
                $27
              </span>
            </div>
            <div className="text-6xl lg:text-8xl font-bold text-brand-green tracking-tighter text-glow-green" data-id="element-135">
              $15
            </div>
            <div className="text-sm text-brand-gray mt-2" data-id="element-136">
              One-time investment. Flash price expires soon.
            </div>
          </div>

          <Button size="xl" fullWidth className="max-w-md mx-auto mb-6" onClick={() => {
          trackEvent('AddToCart', {
            content_name: 'The Wearable Fix',
            content_ids: ['53082097385788'],
            content_type: 'product',
            value: 15,
            currency: 'USD'
          });
          window.location.href = 'https://www.coimarstore.com/cart/53082097385788:1';
        }} data-id="element-137">
            GET THE WEARABLE FIX NOW
          </Button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-gray font-mono" data-id="element-138">
            <div className="flex items-center gap-2" data-id="element-139">
              <Zap className="w-4 h-4 text-brand-green" data-id="element-140" />
              <span data-id="element-141">Instant Digital Delivery</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-142">
              <Lock className="w-4 h-4 text-brand-green" data-id="element-143" />
              <span data-id="element-144">100% Secure Checkout</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}